
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Définition de Branding : l’agence ALEO vous l’explique",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez ce qu’est le Branding, pourquoi il est essentiel et comment développer une identité de marque forte pour vous démarquer de la concurrence.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Définition de Branding : l’agence ALEO vous l’explique",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez ce qu’est le Branding, pourquoi il est essentiel et comment développer une identité de marque forte pour vous démarquer de la concurrence.",
        },
      ],
    };
  },
};
